<template>
  <div class="header-wrapper">
    <header class="header">
      <div class="container">
        <ul class="pull-right nav-links">
          <li class="myinfo">
            <span v-if="COMMON && COMMON.user && COMMON.user.id">你好！{{COMMON.user.entName}}{{COMMON.user.name}}</span>
            <ul>
              <li @click="modify()">个人资料</li>
              <li @click="logout()">登出</li>
            </ul>

          </li>

          <!--<li><a target="_blank"-->
          <!--href="http://www.taobao.com/webww/ww.php?ver=3&touid=yidan8com&siteid=cntaobao&status=1&charset=utf-8">-->
          <!--<i class="fa fa-send"></i> 联系客服</a></li>-->
          <!--<li>-->
          <!--<a href="http://www.jianshu.com/nb/16894020" target="_blank"><i class="fa fa-question-circle-o"></i> 使用帮助</a>-->
          <!--</li>-->
        </ul>
        <h1>
       <!--   <router-link to="/" class="router-link-active" v-if="yuming()">
            &lt;!&ndash;<img src="../assets/images/logo_200x100.png" class="nav-logo">&ndash;&gt;
            <img src="../assets/images/zhongaologo.jpg" class="nav-logo"><span>奥客易</span>

          </router-link>-->
          <router-link to="/" class="router-link-active" >
            <img src="../assets/images/app-icon.png" class="nav-logo"><span>正易易call</span>

          </router-link>
        </h1>
        <ul class="top-menu" v-if="COMMON && COMMON.user ">
          <!-- <template v-for="item in menus.menus">
               <li v-if="checkFeature(item.authCode)">
                   <router-link v-if="item.route" :to="item.route" :class="{'active': item.active}">
                       {{item.name}}
                   </router-link>
               </li>
           </template>-->
          <template v-for="(item,index) in menus.menus">
            <li v-if="checkFeature(item.authCode)">
              <a :class="{'active': item.active}" href="javacript:void(0);" @click="topMemuClick(item)"
                 :ref="'topmenulia_'+index">
                {{item.name}}
              </a>
            </li>
          </template>
        </ul>

      </div>
    </header>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss" scoped>
  .header-wrapper {
    height: 50px;
    line-height: 50px;
    color: #fff;
    .header {
      background: #262626;
      height: 100%;
      .container {
        width: 100%;
        h1 {
          margin: 0;
          float: left;
          font-size: 32px;
          font-weight: 400;
          a {
            display: block;
            height: 45px;
            margin: 4px 0 0 6px;
            img {
              height: 20px
            }
            span {
              color: white;
              font-size: 14px;
              vertical-align: middle;
              margin: 0px 3px;
            }
          }
        }
        ul.top-menu {
          margin-left: 200px;
          // overflow: hidden;
          li {
            float: left;
            a, a:hover, a:visited, a:focus {
              padding: 0 13px;
              color: #fff;
              text-decoration: none;
              display: block;
            }
            a:hover {
              background: #666;
            }
            a.active {
              background: #656262;
            }
          }
        }
        ul.nav-links {
          // overflow: hidden;
          li {
            font-size: 12px;
            float: left;
            margin: 0 5px;
            a, a:hover, a:visited, a:focus {
              color: #fff;
              text-decoration: none;
            }

          }
          .myinfo {
            position: relative;
            cursor: pointer;
            min-width: 80px;
            text-align: center;
            ul {
              display: block;
              opacity: 0.2;
              filter: Alpha(opacity=0);
              line-height: 30px;
              position: absolute;
              right: 0;
              boder: 1px solid #666;
              bottom: -110%;
              width: 100%;
              max-width: 120px;
            }
          }
          .myinfo:hover {
            ul {
              padding: 0px;
              margin: 0px;
              opacity: 1;
              filter: Alpha(opacity=100);
              transition: opacity 1s;
              display: block;

              background: black;
              z-index: 99;
              li {
                color: white;
                text-align: center;
                height: 30px;
                float: left;
                width: 100%;
                padding: 0px;
                margin: 0px;
              }
              li:hover {
                background: #666;
              }
            }
          }
        }
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import {mapState, mapGetters} from 'vuex'
  import menus from './menus'
  import MyInfo from '../modules/user/components/MyInfo.vue'

  export default {
    data() {
      return {
        menus, MyInfo
      }
    },
    methods: {
      logout() {//登出操作
        this.$http
          .get('/api/account/exit')
          .then(({data}) => {
            if (data.success) {
              window.location.href="/";
            }
          })
      },
      modify() {
        this.$layer.dialog({
          title: '个人资料',
          component: MyInfo,
          confirm: (result) => {

          }
        })
      },
      topMemuClick(item) {
        if (this.goTopMenuUrl) {
          this.goTopMenuUrl = false;
        }
        if (item.route) {//有配置rotue的
          if (this.checkFeature(item.authCode)) {
            this.$router.push(item.route)
          } else {
            return;
          }
        } else {//没有配置route的
          this.findChildrenMenu(item);
          this.$router.push(this.goTopMenuUrl)
        }

      },
      findChildrenMenu(item) {
        var _this = this;
        if (item.children) {
          var chil = item.children;
          for (var i = 0; i < chil.length; i++) {
            var chilobj = chil[i];
            if (_this.checkFeature(chilobj.authCode) && chilobj.route && !_this.goTopMenuUrl) {
              console.log(chilobj.route + "============");
              _this.goTopMenuUrl = chilobj.route;
              break;
            } else {
              _this.findChildrenMenu(chilobj);
            }
          }
        }
      }
    },
    computed: {
      ...mapState([
        'COMMON'
      ]),
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/layout/TopBar.vue